import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'

interface RequireDocumentationAuthProps {
  children: React.ReactNode
}

export const RequireDocumentationAuth: React.FC<RequireDocumentationAuthProps> = ({ children }) => {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-[#f5f8f4] via-white to-[#eef4ed] flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#3d874e] mx-auto"></div>
          <p className="mt-4 text-[#1f2a3d]">Loading...</p>
        </div>
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/ai-doc/login" replace />
  }

  return <>{children}</>
}
